import React, { useState } from "react";
import { FiCopy, handleCopy } from "@/components/common/commonFunction/handleCopy";

function RemoveSpace() {
  const [changeupWspace, setChangeupWspace] = useState("");
  const [copy, setCopy] = useState(false);
  const [text, setText] = useState("");
  const [errors, setErrors] = useState("");

  const handleOnErase = () => {
    setText("");
    setCopy(false);
    setChangeupWspace("");
  };

  const handleOnChange = (event) => {
    setErrors("");
    setChangeupWspace("");
    setCopy(false);
    setText(event.target.value);
  };

  const handleWhiteSpace = () => {
    if (!text || text.trim() === "") return setErrors("* Please enter text.");
    let e = document.getElementById("WhiteSpace");
    let value = e.value;
    if (value == "All") {
      setChangeupWspace(text.replace(/[ ]+/g, ""));
    } else {
      setChangeupWspace(text.replace(/\s{2,}/g, " ").trim());
    }
    setCopy(false);
  };

  return (
    <>
      <div className="main-globally-counter-box">
        {text?.length > 0 && (
          <div className="color-picker-icon">
            <i
              className="fa-solid fa-eraser"
              title="Clear"
              onClick={handleOnErase}
            ></i>
          </div>
        )}
        <div className="counter-text-area">
          <textarea
            className={errors && "error-input"}
            placeholder="Enter text to remove white-spaces..."
            value={text}
            onChange={handleOnChange}
          />
          <span>{errors}</span>
        </div>
      </div>
      <div className="commom-box-new truncate-text-top-alignment">
        <div className="input-new">
          <select
            id="WhiteSpace"
            onChange={() => {
              setChangeupWspace("");
            }}
          >
            <option value="Extra">Extra WhiteSpaces Remove</option>
            <option value="All">All WhiteSpaces Remove</option>
          </select>
        </div>
      </div>
      <div className="button lowercase-center-alignment">
        <button onClick={handleWhiteSpace}>Convert</button>
      </div>
      {changeupWspace?.length > 0 && (
        <div className="main-globally-counter-box">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(changeupWspace)} />
            {copy && changeupWspace && (
              <div>
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="counter-text-area">
            <textarea value={changeupWspace} className="text-black" disabled />
          </div>
        </div>
      )}
    </>
  );
}
export default RemoveSpace;
